import { useState, ChangeEvent, Dispatch, SetStateAction } from 'react';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';

import theme from '@styles/theme';
import { onlyNumber } from '@utils/common';
import { CREATE_PET_QR } from '@graphql/mutations';
import { SEE_CREATED_QR_LIST } from '@graphql/queries';
import { Mutation } from '@graphql/types';

import { FlexBox } from '@components/styled/StyledComponents';
import StyledModal from '@components/styled/StyledModal';
import StyledInput from '@components/styled/StyledInput';
import StyledButton from '@components/styled/StyledButton';

type PublishQRModalProps = {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const PublishQRModal = ({ isOpen, setIsOpen }: PublishQRModalProps) => {
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);

    const [createPetQR] =
        useMutation<Pick<Mutation, 'createPetQR'>>(CREATE_PET_QR);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setAmount(onlyNumber(value));
    };

    const onSubmit = async () => {
        if (!amount) return toast.warning('수량을 입력해주세요.');

        setLoading(true);

        try {
            await createPetQR({
                variables: {
                    amount: +amount
                },
                onCompleted: () => {
                    toast.success('QR이 발행됐습니다.');
                    setIsOpen(false);
                },
                refetchQueries: [SEE_CREATED_QR_LIST]
            });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <StyledModal
            title="QR 발행"
            isOpen={isOpen}
            closeBtnHandler={() => setIsOpen(false)}
            marginBottom={24}
        >
            <StyledInput
                name="amount"
                title="수량"
                value={amount}
                onChange={onChange}
                placeholder="발행 수량을 입력해주세요."
                margin="0 0 24px"
                COLUMN
            />
            <FlexBox $gap={8} $justifyContent="flex-end">
                <StyledButton
                    title="취소"
                    width={140}
                    bgColor={theme.colors.whiteColor}
                    fontColor={theme.colors.blackColor}
                    border={`${theme.colors.lightGrayBorder} 1px solid`}
                    onClick={() => setIsOpen(false)}
                />
                <StyledButton
                    title="발행"
                    width={140}
                    bgColor={theme.colors.pointGreen}
                    onClick={onSubmit}
                    loading={loading}
                />
            </FlexBox>
        </StyledModal>
    );
};

export default PublishQRModal;
